import { useGetStatsQuery } from '@platform/state/api';
import type { IRecordListModel } from '@platform/core/types';
import { useListParams } from '../list/useListParams';
import type { IListStats } from './IListStats';

/**
 * Статистика за полем `by` для записів, що відповідають фільтрам списку (patterns/filtering: фільтри діють на всі подання, панель показників
 * теж): фільтр, пресет і пошук — у запит статистики (API застосовує `q` так само, як до списку).
 */
export function useListStats(model: IRecordListModel, by: string): IListStats {
  const params = useListParams(model);
  const stats = useGetStatsQuery({ ws: model.ws, rt: model.rt.key, by, params });
  return { data: stats.data, isError: stats.isError };
}
